<template>
  <div>
    <!--配货工作状况： -->
    <el-dialog :title="$t('message.pickingWorkStatus')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1400px" center>
      <div class="content">
        <div class="search">
          <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" clearable placeholder="选择时间">
          </el-date-picker>
          <!-- 搜索 -->
          <el-button type="primary" @click="dataSpeedPlist">{{ $t('message.search') }}</el-button>
        </div>
        <div class="table">
          <ol>
            <li>配货名称</li>
            <li>当天的包裹数</li>
            <li>待拆包包裹数</li>
            <li>待上架番数</li>
            <li>未到包裹数</li>
            <li>待捆包配送单数量</li>
            <li>当前拆包进度</li>
            <li>当前上架进度</li>
            <li>当下配送单操作日期</li>
            <li>待打包的退换货包裹</li>
          </ol>
          <!-- 无数据显示 -->
          <div class="noData" v-if="tableData == false">暂无数据</div>
          <ul v-for="(item, index) in tableData" :key="index">
            <li>{{ item.admin_name }}</li>
            <li>{{ item.receive_package }}</li>
            <li>{{ item.wait_open_package }}</li>
            <li>{{ item.wait_up_sorting }}</li>
            <li>{{ item.wait_receive_package }}</li>
            <li>{{ item.wait_pack_porder }}</li>
            <li>{{ item.wait_open_datetime }}</li>
            <li>{{ item.wait_up_datetime }}</li>
            <li>{{ item.wait_pack_porder_datetime }}</li>
            <li>{{ item.wait_pack_refund }}</li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      date: '',
      tableData: []
    };
  },
  methods: {
    dataSpeedPlist() {
      this.$api.inspectionApi.dataSpeedPlist({ date: this.date }).then(res => {
        this.tableData = res.data
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;

  .search {
    display: flex;
    margin-bottom: 24px;

    .el-button {
      margin-left: 20px;
    }
  }

  .table {
    max-height: 600px;
    overflow-y: auto;
    position: relative;
    border: 1px solid #dcdfe6;
    border-bottom: 0;

    ol {
      position: sticky;
      top: 0;
      left: 0;

      li {
        box-sizing: border-box;
        border-right: 1px solid #dcdfe6;
        border-bottom: 1px solid #dcdfe6;
      }

      li:last-child {
        border-right: 0;
      }
    }

    ul {
      li {
        box-sizing: border-box;
        border-right: 1px solid #dcdfe6;
        border-bottom: 1px solid #dcdfe6;
      }

      li:last-child {
        border-right: 0;
      }
    }
  }
}



.noData {
  padding: 20px 0;
  text-align: center;
}
</style>
